import { WildfireFeature } from '../features/alert-wildfire/alert-wildfire.feature';
import { StandardLayerRenderer } from './standard-layer.renderer';

export class AlertsWildfireLayerRenderer extends StandardLayerRenderer {
  protected Feature = WildfireFeature
}
